import { Control, Controller, FieldValues, Path, RegisterOptions } from 'react-hook-form'
import { StyledInputLabel } from 'Components/Inputs/StyledInputLabel'
import { StyledSelect } from 'Components/Inputs/StyledSelect'
import { InputContainer } from './ControlledSelect'

export type ControlledStyledSelectProps<T extends FieldValues> = {
  label: string
  name: Path<T>
  options: any[]
  control: Control<T>
  errorPresent?: boolean
  rules?: RegisterOptions<T, Path<T>>
  disabled?: boolean
  defaultValue?: any
  placeholder?: string
}

export const ControlledStyledSelect = <T extends FieldValues>({
  label,
  name,
  options,
  control,
  errorPresent,
  disabled,
  defaultValue,
  rules,
  placeholder = 'Select an option...'
}: ControlledStyledSelectProps<T>) => (
  <Controller
    rules={rules}
    control={control}
    name={name}
    render={({ field: { onChange, value } }) => (
      <InputContainer id={`scroll_${name}`}>
        <StyledInputLabel>{label}</StyledInputLabel>
        <StyledSelect
          errorPresent={errorPresent ?? false}
          options={options}
          handleChange={onChange}
          defaultValue={value !== undefined && value !== null ? value : defaultValue}
          placeholderText={placeholder}
          disabled={disabled}
        />
      </InputContainer>
    )}
  />
)
